import { Helmet } from "react-helmet";

function SEO(props) {
  const { children, ...customMeta } = props;
  const meta = {
    title: "EQUITY | Equity - Perpetual trading exchange",
    description: `Trade spot or perpetual ETH, FTM and other top cryptocurrencies with up to 30x leverage directly from your wallet on Fantom.`,
    // description: `Trade spot or perpetual BTC, ETH, FTM and other top cryptocurrencies with up to 30x leverage directly from your wallet on Fantom.`,
    image: "https://equity.exchange/android-chrome-512x512.png",
    type: "exchange",
    ...customMeta,
  };
  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="robots" content="follow, index" />
        <meta content={meta.description} name="description" />
        <meta property="og:type" content={meta.type} />
        <meta property="og:site_name" content="EQUAL" />
        <meta property="og:description" content={meta.description} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:image" content={meta.image} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@Equal" />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={meta.image} />
      </Helmet>
      {children}
    </>
  );
}

export default SEO;
